import { render } from "./PermitsMenuWithLls.vue?vue&type=template&id=e9d9d528"
import script from "./PermitsMenuWithLls.vue?vue&type=script&lang=js"
export * from "./PermitsMenuWithLls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__